
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.7 20c-.1 0-.2 0-.3-.1l-1-.6C7.1 17.1 5 13.6 4.7 9.8c0-.1-.2-2.2-.2-3 0-.4.2-.7.6-.8l6.3-2h.6l6.3 2c.3.1.6.4.6.8 0 .8-.2 2.9-.2 3-.3 3.8-2.4 7.3-5.6 9.4l-1 .6c-.2.1-.3.2-.4.2zM5.9 7.2c.1 1 .2 2.4.2 2.5.3 3.4 2.1 6.5 5 8.4l.6.4.6-.4c2.8-1.8 4.7-5 5-8.3 0 0 .1-1.5.2-2.4l-5.7-1.8-5.9 1.6z"}}),_c('path',{attrs:{"d":"M14.9 8.9c-.3-.3-.8-.3-1.1 0l-3 3-.9-.9c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l1.4 1.4c.3.3.8.3 1.1 0l3.5-3.5c.4-.4.4-.8.1-1.1z"}})])
          )
        }
      }
    